import {lazy, Suspense} from 'react'
import {ErrorBoundary} from '@sentry/react'

import {Loading} from '@sdox/ui'

import {useIsEditable} from '../DragAndDrop'
import {BlockMapper} from './BlockMapper'
import {BlockError} from './BlockError'

import type {XcNwBlockFragment} from '@sdox/api'

const DndBlockWrapper = lazy(() => import('../DragAndDrop/DragAndDropBlock'))

export const Block = (props: XcNwBlockFragment) => {
  const isEditable = useIsEditable() && props.isEditable

  if (isEditable) {
    return (
      <Suspense fallback={<Loading />}>
        <DndBlockWrapper
          block={props}
        >
          {/*
            The ErrorBoundary must be a child of the dnd wrapper and the mapper so the block can
            still be edited (e.g. deleted) when there is an error inside the block
          */}
          <ErrorBoundary
            key={props.id}
            fallback={({resetError}) => (
              <BlockError resetError={resetError} />
            )}
          >
            <BlockMapper {...props} />
          </ErrorBoundary>
        </DndBlockWrapper>
      </Suspense>
    )
  }

  return (
    <div id={props.id}>
      <BlockMapper {...props} />
    </div>
  )
}
